import { useSignalROn } from "@/helpers/signalr.ts";
import { SigROn } from "@/types/signalr-functions.ts";
import { useCallback } from "react";
import type { FlowGeneratorSession } from "@/types/flow.ts";
import { useActiveSessionStore } from "@/stores/useActiveSessionStore.ts";

export const useHookAllChatUpdate = () => {
  const { AddNewSession, AddHelpRequestedSession, RemoveHelpRequestedSession, RemoveSession } =
    useActiveSessionStore();

  const updatedSessionCallback = useCallback(
    (updatedSession: Partial<FlowGeneratorSession>) => {
      if (!updatedSession.flowGeneratorSessionId) return;

      if (updatedSession.tutorId) {
        AddNewSession(updatedSession.tutorId, updatedSession);
        RemoveHelpRequestedSession(updatedSession);
      } else {
        RemoveSession(updatedSession);

        if (updatedSession.isHelpRequested) {
          AddHelpRequestedSession(updatedSession);
        } else {
          RemoveHelpRequestedSession(updatedSession);
        }
      }
    },
    [AddNewSession, AddHelpRequestedSession, RemoveHelpRequestedSession, RemoveSession],
  );

  useSignalROn(SigROn.DispatchFlowGeneratorSession, updatedSessionCallback);
};
